module.exports = __webpack_public_path__ + "static/media/info.d02065a7.svg";